import { api } from '@/lib/api'

export async function listUserRoles(userId: number): Promise<string[]> {
  const r = await api.get<string[]>(`/api/access/users/${userId}/roles`)
  return r.data
}

/** Batch lookup: { [userId]: roleCodes[] }. Users with no roles are absent. */
export async function listRolesForUsers(userIds: number[]): Promise<Record<string, string[]>> {
  if (userIds.length === 0) return {}
  const r = await api.get<Record<string, string[]>>('/api/access/users/roles', {
    params: { userIds: userIds.join(',') },
  })
  return r.data
}

export async function assignUserRole(userId: number, roleCode: string): Promise<void> {
  await api.post(`/api/access/users/${userId}/roles`, { roleCode })
}

export async function revokeUserRole(userId: number, roleCode: string): Promise<void> {
  await api.delete(`/api/access/users/${userId}/roles/${roleCode}`)
}
